// navigation-panel.tsx
import React from 'react';
import { Chip } from '@mui/material';
import {
  BusinessOutlined as CompanyIcon,
  LocationOnOutlined as AddressIcon,
  PeopleOutlined as PeopleIcon,
  FactoryOutlined as FactoryIcon,
  VerifiedUserOutlined as CertificationIcon,
  GroupOutlined as UnionIcon,
  SchoolOutlined as QualificationIcon,
  EngineeringOutlined as MaterialIcon,
  LocalShippingOutlined as VehicleIcon,
  BlenderOutlined as MixerIcon,
} from '@mui/icons-material';

import { NavigationSection } from '../../types/company.types';

import { NavigationPanelLayout, NavigationPanelItem } from '@/components/navigation-panel-common';

interface NavigationPanelProps {
  sections: NavigationSection[];
  activeSection: string;
  onSectionClick: (sectionId: string) => void;
  completedSections?: string[];
}

export const NavigationPanel: React.FC<NavigationPanelProps> = ({
  sections,
  activeSection,
  onSectionClick,
  completedSections = [],
}) => {
  const getIcon = (sectionId: string) => {
    switch (sectionId) {
      case 'basic-info':
        return <CompanyIcon />;
      case 'address-info':
        return <AddressIcon />;
      case 'representatives':
        return <PeopleIcon />;
      case 'factory-info':
        return <FactoryIcon />;
      case 'certifications':
        return <CertificationIcon />;
      case 'union-membership':
        return <UnionIcon />;
      case 'qualified-personnel':
        return <QualificationIcon />;
      case 'raw-materials':
        return <MaterialIcon />;
      case 'transport-vehicles':
        return <VehicleIcon />;
      case 'mixer-info':
        return <MixerIcon />;
      default:
        return <CompanyIcon />;
    }
  };

  return (
    <NavigationPanelLayout>
      {sections.map((section) => {
        const isActive = activeSection === section.id;
        const isCompleted = completedSections.includes(section.id);

        return (
          <NavigationPanelItem
            key={section.id}
            label={section.label}
            isActive={isActive}
            onClick={() => onSectionClick(section.id)}
            icon={getIcon(section.id)}
          >
            {isCompleted && (
              <Chip
                label='完了'
                size='small'
                color='success'
                variant='outlined'
                sx={{ height: 20, fontSize: '0.7rem', '& .MuiChip-label': { px: 1 } }}
              />
            )}
          </NavigationPanelItem>
        );
      })}
    </NavigationPanelLayout>
  );
};
